import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

const UrlRedirects = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [hasRedirected, setHasRedirected] = useState(false)

  useEffect(() => {
    // Éviter les redirections multiples
    if (hasRedirected) return

    const path = location.pathname
    
    // Redirections 301 pour les URLs canoniques
    const redirects = {
      '/conditions-general-de-location/': '/cgv',
      '/projets/': '/filmographie',
      '/privacy-policy/': '/mentions-legales',
      '/politique-de-cookies-ue/': '/politique-confidentialite',
      '/catalogue-location-materiel-tournage-guadeloupe/': '/catalogue-materiels',
      '/departement-camera/': '/catalogue-materiels?parent_category=image'
    }

    // Vérifier si l'URL actuelle nécessite une redirection
    if (redirects[path]) {
      console.log(`🔄 Redirection 301: ${path} → ${redirects[path]}`)
      setHasRedirected(true)
      
      // Utiliser window.location.replace pour une vraie redirection 301
      // Cela évite les problèmes de React Router et force le rechargement
      window.location.replace(redirects[path])
    }
  }, [location.pathname, navigate, hasRedirected])

  return null // Ce composant ne rend rien
}

export default UrlRedirects
